/**
 * notify.ts — thin wrapper over the Angular NotificationService toast queue.
 *
 * The React analog of Angular's addSuccess/addError/addInfo: one import, one chokepoint.
 * Digest scheduling is handled inside getNotificationService() (see angular-bridge.ts), so
 * these are safe to call from React event handlers and TanStack mutation callbacks.
 */
import { getNotificationService } from './angular-bridge';

export interface ToastConfig {
  title: string;
  description?: string;
  timeout?: number;
  buttons?: string;
}

export type ToastInput = string | ToastConfig;

const toConfig = (input: ToastInput): ToastConfig =>
  typeof input === 'string' ? { title: input } : input;

export const notifySuccess = (input: ToastInput) => getNotificationService().addSuccess(toConfig(input));
export const notifyError = (input: ToastInput) => getNotificationService().addError(toConfig(input));
export const notifyInfo = (input: ToastInput) => getNotificationService().addInfo(toConfig(input));
